import { render, staticRenderFns } from "./FixedPriceForm.vue?vue&type=template&id=85cf7098"
import script from "./FixedPriceForm.vue?vue&type=script&lang=js"
export * from "./FixedPriceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports